import Upload from '../../../../../common/components/element-ui-templated/upload/index.vue';
export default {
	extends: Upload
};
